import { normalizeCareContext } from "../../../utils/careContext";
import { normalizeSupportProfile } from "../../../utils/supportProfile";
import { normalizeCareFocusSelection } from "../../../constants/childProfileOptions";
import { EMPTY_PROFILE_DOCUMENTS } from "./profileSnapshot";
import { resolveProfileMedicationDetails } from "./profileMedicationHydration";

export const buildEditChildProfileLoadState = (child = {}) => {
  const medicalProfile = child?.medicalProfile || {};
  const selectedConditions = normalizeCareFocusSelection(child?.concerns || child?.conditions || []);
  const supportProfile = normalizeSupportProfile(child?.supportProfile || child?.supportGoals || {});
  const careContext = normalizeCareContext({
    ...(child?.careContext || {}),
    careFocus: selectedConditions,
  });
  const profileDocuments = child?.profileDocuments || EMPTY_PROFILE_DOCUMENTS;
  const foodAllergies = medicalProfile.foodAllergies || [];
  const dietaryRestrictions = medicalProfile.dietaryRestrictions || [];
  const sensoryIssues = medicalProfile.sensoryIssues || [];
  const behavioralTriggers = medicalProfile.behavioralTriggers || [];
  const communicationNeeds = medicalProfile.communicationNeeds || [];

  return {
    childId: child?.id || "",
    name: child?.name || "",
    age: child?.age || "",
    dateOfBirth: child?.dateOfBirth || "",
    photoURL: child?.photoURL || null,
    snapshotPhotoURL: child?.photoURL || "",
    selectedConditions,
    medicalProfile,
    foodAllergies,
    dietaryRestrictions,
    sensoryIssues,
    behavioralTriggers,
    communicationNeeds,
    careContext,
    supportProfile,
    profileMedicationDetails: resolveProfileMedicationDetails({
      medicationRecords: child?.medicationRecords || [],
    }),
    profileDocuments,
    snapshotState: {
      name: child?.name || "",
      age: child?.age || "",
      dateOfBirth: child?.dateOfBirth || "",
      photoURL: child?.photoURL || "",
      photoName: "",
      selectedConditions,
      foodAllergies,
      dietaryRestrictions,
      sensoryIssues,
      behavioralTriggers,
      communicationNeeds,
      careContext,
      supportProfile,
      uploadedDocuments: profileDocuments,
    },
  };
};
